import React, { Component } from 'react';
import style from '../../style/style';
import Loading from '../loading';
import Key from '../../static/img/key.svg'
import numeral from 'numeral';
import median from 'median';

class AirBnb extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.data) return (<Loading fill={style.colors.primary} height="32px" width="32px" container={true} />);
    const { data } = this.props;
    //const area = toTitleCase(data.data.LE_ENGLISH);
    const count =  data.ptsWithin.features.length;
    const distance = data.distance;
    const properties = data.ptsWithin.features;
    //console.log(properties);

    let total = 0;
    let priceArr = [];
    properties.forEach(function(property) {
      //console.log(numeral(property.properties.price));
      priceArr.push(numeral(property.properties.price)._value);
      total = total + numeral(property.properties.price)._value;
      property.formattedPrice = numeral(property.properties.price).format('(0.00)');
    });

    const avgPrice = numeral(total/count).format('(0)');
    const medPrice = numeral(median(priceArr)).format('(0)');


    return (
      <div 
        style={{ ...style.fact.layout }}
      >
        <div style={{ ...style.fact.left }}>
          <img src={Key} style={{ width: style.fact.left.width, padding: style.padding, fill: style.colors.primary }} />
        </div>
        <div style={{ ...style.fact.right }}>
          <h2 style={{ ...style.fact.heading, marginBottom: 0 }}>
            { `€${medPrice} Airbnb cost per night` }
          </h2>
          <p style={{ marginTop: 0, marginBottom: "0.5rem" }}>{`This value is based on median of ${count} Airbnbs listed within ${distance}.`}</p>
          <div style={{ ...style.fact.source, paddingTop: 0 }}>Source: Airbnb data feb 2017, <a href="http://insideairbnb.com/get-the-data.html">insideairbnb.com</a>.</div>
          <span
            style={{
              textTransform: "uppercase",
              fontSize: "11px",
              color: "#333",
              padding: "0.25rem 0.5rem",
              border: "1px solid #333",
              borderRadius: "4px"
            }}>Beta</span>

        </div>
      </div>);
  }
}

export default AirBnb;



// WEBPACK FOOTER //
// ./src/components/airbnb/index.js